
import { IGetOTPResponse } from "types/auth/IGetOTPResponse"; 
import { baseApi } from "./base.api";
import { IVerifyOtp, IRegister } from "../types/auth/IAuth";
export const authApi = baseApi.injectEndpoints({
  
  endpoints: (builder) => ({
    getOTP: builder.query<{ isNewUser: boolean }, string>({
      query: (phoneNumber) => ({
        url: "/auth/otp",
        method: "GET",
        params: { phoneNumber },
      }),
      transformResponse: (response: IGetOTPResponse) => response.data,
    }),

    postOtp: builder.mutation({
      query: (userData: IVerifyOtp) => ({
        url: "/auth/otp",
        method: "POST",
        body: userData,
      }),
      transformResponse: (response: { data: any }) => {
        localStorage.setItem("Access-token", response.data.token);
        return response.data;
      },
    }),

    register: builder.mutation({
      query: (registerData: IRegister) => ({
        url: "/auth/register",
        method: "POST",
        body: registerData,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetOTPQuery,
  usePostOtpMutation,
  useRegisterMutation,
} = authApi;
